import { useState, useEffect, useContext } from "react";
import {
  FormControl,
  Grid,
  TextField,
  Typography,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from "@mui/material";
import {
  _ACTIONS,
  _BAIL_A_NOURRITURE,
  _COLORS,
  _GESTION_VIAGERE,
  _STATUTCOLORS,
  _VENTE_TRADITIONNELLE,
} from "../../../utils/_constants";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import _ from "lodash";
import { editInstantRequest } from "../../../utils/formHelper";
import Mandant from "./Mandant";
import { _STYLES } from "../../../utils/_style_constants";
import { RequestHelper } from "../../../utils/requestHelper";
import { UserContext } from "../../contexts/UserContext";
import { useParams } from "react-router";
import { createConfirm } from "../../../utils/confirm";
import RemunerationAgence from "./RenumerationAgence";
import AnnexesDocumentaires from "./AnnexesDocumentaires";
import BoxActionOffreAchat from "./BoxActionOffreAchat";
import VentilationPrixLettreIntentionAchat from "./VentilationPrixLettreIntentionAchat";
import MouseOverPopover from "../MouseOverPopover";
import HelpIcon from "@mui/icons-material/Help";

const CreationOffreAchat = ({
  register,
  currentMandat,
  setCurrentMandat,
  disabledSign = false,
  refresh,
  errors,
}) => {
  const { user } = useContext(UserContext);
  const [typeMandants, setTypeMandants] = useState([]);
  const [civilites, setCivilites] = useState([]);
  const [refreshMandat, setRefreshMandat] = useState(0);
  const [typeVentes, setTypeVentes] = useState([]);
  const [users, setUsers] = useState([]);
  const [indices, setIndices] = useState([]);
  const [typeDocuments, setTypeDocuments] = useState([]);
  const requestHelper = new RequestHelper();
  const currentIdUrl = useParams();
  const [vendeur, setVendeur] = useState([]);

  const mandantListNonSignataire = currentMandat?.mandants?.filter(
    (mandants) =>
      (mandants.onlyForSignature === false ||
        mandants.onlyForSignature === null) &&
      mandants.isVendeur === false,
  );

  const mandantVendeur = currentMandat?.mandants?.filter(
    (mandants) => mandants.isVendeur === true,
  );
  const getMandatById = () => {
    requestHelper
      .doRequest(_ACTIONS.GET, `/api/mandats/${currentIdUrl.id}`)
      .then((response) => {
        if (response.status === 200) {
          setCurrentMandat(response.data);
        }
      });
  };

  /* GET User Entity */
  useEffect(() => {
    getCivilite();
    getUsers();
    getTypeMandant();
    getIndice();
    getTypeDeVente();
    getTypeDocument();
  }, []);

  useEffect(() => {
    if (currentMandat) {
      // On récupére le vendeur
      // On filtre la liste des mandants pour ne garder que ceux qui sont vendeurs
      // et on prend le premier de la liste
      // Si il n'y a pas de vendeur, on met le vendeur à null
      // Si il y a un vendeur, on le met dans le state
      const vendeurList = currentMandat?.mandants?.filter(
        (mandant) => mandant?.isVendeur === true,
      );
      if (vendeurList && vendeurList.length > 0) {
        setVendeur(vendeurList[0]);
      }
    }
  }, [currentMandat]);

  const getTypeDeVente = () => {
    requestHelper.get("/api/type_ventes").then((response) => {
      /** Filtre Pour gestion Viagére à mettre uniquement pour admin et sadmin */
      let arrayList = response.data["hydra:member"];
      let finalArrayList = [];
      arrayList.forEach((item) => {
        if (user.profil === "SUSER" || user.profil === "USER") {
          if (
            item.nom !== _GESTION_VIAGERE &&
            item.nom !== _VENTE_TRADITIONNELLE &&
            item.nom !== _BAIL_A_NOURRITURE
          ) {
            finalArrayList.push(item);
          }
        } else {
          finalArrayList.push(item);
        }
      });
      setTypeVentes(finalArrayList);
    });
  };

  const getTypeDocument = () => {
    requestHelper.get("/api/type_documents").then((response) => {
      setTypeDocuments(response.data["hydra:member"]);
    });
  };

  const getTypeMandant = () => {
    requestHelper.get("/api/type_mandants").then((response) => {
      setTypeMandants(response.data["hydra:member"]);
    });
  };

  const getIndice = () => {
    requestHelper.get("/api/indices").then((response) => {
      setIndices(response.data["hydra:member"]);
    });
  };

  const getCivilite = () => {
    requestHelper.get("/api/civilites").then((response) => {
      setCivilites(response.data["hydra:member"]);
    });
  };

  const getUsers = () => {
    // on récupére l'agence du mandat
    let agenceAPi = currentMandat?.agence ? currentMandat.agence.id : "";
    // si le mandat est null, on récupére l'agence de l'utilisateur
    if (
      agenceAPi === "" &&
      !_.isUndefined(user.agencesList) &&
      users.length === 0
    ) {
      agenceAPi = user.agencesList;
      // on supprime la derniére virgule
      if (agenceAPi[agenceAPi.length - 1] === ",") {
        agenceAPi = agenceAPi.slice(0, -1);
      }
      let param = [];
      agenceAPi = agenceAPi.split(",");
      agenceAPi.forEach((element, index) => {
        param.push("agences[]=" + element);
      });
      param.push("represent=true");
      param.push("actif=true");

      requestHelper.get("/api/users?" + param.join("&")).then((response) => {
        setUsers(response.data["hydra:member"]);
      });
    }
  };

  useEffect(() => {
    getUsers();
    /* GET Mandat by Id */
    getMandatById();
  }, [refreshMandat, user]);

  return (
    <>
      <Grid item xs={12} md={12}>
        <Typography
          variant="h5"
          style={{
            fontWeight: "bold",
            color: _COLORS.primary,
            paddingBottom: 20,
          }}
        >
          {currentMandat.typeVente !== null ? "Modification de la présentation d'une lettre d'intention d'achat" : "Création de la présentation d'une lettre d'intention d'achat"}
          
        </Typography>
      </Grid>
      <Grid item xs={12}>
        Statut : &nbsp;
        <strong>
          <span
            style={{
              color: currentMandat.statut
                ? _STATUTCOLORS[currentMandat?.statut?.nomTechnique]
                : "black",
            }}
          >
            {currentMandat.statut ? currentMandat?.statut?.nom : "N/A"}
          </span>
        </strong>
      </Grid>
      <Grid container columnSpacing={1} rowSpacing={2} padding={4}>
        <InputLabel id="dateLabel" size="small" sx={{ color: "black" }}>
          Le*
        </InputLabel>{" "}
        <DatePicker
          sx={{ paddingLeft: "10px", marginTop: "10px" }}
          size="small"
          value={
            currentMandat.dateOffreAchat
              ? moment(currentMandat.dateOffreAchat)
              : null
          }
          format="DD/MM/YYYY"
          onChange={(date) => {
            let dateToSend = date?.toLocaleString("fr-FR", {
              timeZone: "Europe/paris",
            });
            if (dateToSend !== "Invalid date") {
              editInstantRequest(
                _.isNull(dateToSend) ? null : dateToSend,
                currentMandat["@id"],
                "dateOffreAchat",
              );
              refresh();
            }
          }}
          slotProps={{
            textField: {
              size: "small",
            },
          }}
        />
        <Grid item xs={12} md={2} />
        <Grid item xs={1}>
          <Typography>Type de vente*</Typography>
        </Grid>
        <Grid item xs={6} md={4}>
          <FormControl fullWidth>
            <InputLabel id="typeVenteLabel" size="small">
              Type de vente
            </InputLabel>
            <Select
              label="Type de vente"
              size="small"
              disabled={disabledSign}
              value={
                currentMandat?.typeVente ? currentMandat.typeVente["@id"] : ""
              }
              {...register("typeVente", { required: false })}
              id="typeVente"
              onChange={(e) => {
                if (!_.isNull(currentMandat?.typeVente)) {
                  createConfirm(
                    "Êtes-vous sûr de vouloir modifier le type de vente ? (Les ventilations de prix déjà existantes seronts supprimées)",
                  )
                    .fire({})
                    .then((result) => {
                      if (result.isConfirmed) {
                        // Traitement
                        let m = editInstantRequest(
                          e.target.value,
                          currentMandat["@id"],
                          "typeVente",
                        );

                        m.then((m) => {
                          setCurrentMandat(m);
                        });
                      } else {
                        // Annulation
                        setCurrentMandat(currentMandat);
                      }
                    });
                } else {
                  let m = editInstantRequest(
                    e.target.value,
                    currentMandat["@id"],
                    "typeVente",
                  );

                  m.then((m) => {
                    setCurrentMandat(m);
                  });
                }
              }}
            >
              {typeVentes.map((typeVente, i) => (
                <MenuItem key={i} value={typeVente["@id"]}>
                  {typeVente.nom}
                </MenuItem>
              ))}
            </Select>
            {errors.typeVente?.type === "required" && (
              <Typography sx={_STYLES.errorMessage}>
                Veuillez selectionner un type de vente
              </Typography>
            )}
          </FormControl>
        </Grid>
      </Grid>
      {/** VENDEUR */}
      <Grid
        container
        columnSpacing={1}
        rowSpacing={1}
        padding={2}
        sx={{ alignItems: "center" }}
      >
        <Grid sx={{ ..._STYLES.sxGridChild }}>
          <Mandant
            register={register}
            errors={errors}
            typeMandants={typeMandants}
            setTypeMandants={setTypeMandants}
            currentMandat={currentMandat}
            setCurrentMandat={setCurrentMandat}
            civilites={civilites}
            refresh={refresh}
            requestHelper={requestHelper}
            disabledSign={disabledSign}
            mandantListNonSignataire={mandantVendeur}
            mandant={vendeur}
            vendeur={true}
          />
        </Grid>
      </Grid>
      {/** PROPOSANTS - ACHETEUR */}
      <Grid
        container
        columnSpacing={1}
        rowSpacing={1}
        padding={2}
        sx={{ alignItems: "center" }}
      >
        <Grid sx={{ ..._STYLES.sxGridChild }}>
          <Grid container columnSpacing={1} rowSpacing={1} padding={4}>
            <Grid item xs={12} direction={"row"} display={"flex"}>
              <Typography
                variant="h5"
                style={{
                  fontWeight: "bold",
                  color: _COLORS.primary,
                  paddingRight: "10px",
                }}
              >
                Proposants
              </Typography>{" "}
              <MouseOverPopover
                sx={{
                  marginLeft: "25px",
                  width: "350px",
                }}
                title={<HelpIcon />}
                popoverText="Champ libre, mettre nom et adresse du proposant. Ex : M. Dupont, demeurant 25 rue Victor Hugo, 85000, Les Sables d'Olonne"
              />
            </Grid>
            <Grid item xs={12} md={6} alignItems={"center"} display={"flex"}>
              <TextField
                fullWidth
                size="large"
                id="proposants"
                label="Proposants"
                value={
                  currentMandat?.proposants ? currentMandat.proposants : ""
                }
                // Besoin de changer la valeur du state pour que le composant se rafraichisse
                onChange={(e) => {
                  setCurrentMandat({
                    ...currentMandat,
                    proposants: e.target.value,
                  });
                }}
                // On envoie la valeur au serveur
                onBlur={(e) => {
                  let m = editInstantRequest(
                    e.target.value,
                    currentMandat["@id"],
                    "proposants",
                  );
                  refresh();
                }}
                helperText={
                  errors?.proposants?.type === "required" && (
                    <Typography sx={_STYLES.errorMessage}>
                      Proposants est requis
                    </Typography>
                  )
                }
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          columnSpacing={1}
          rowSpacing={1}
          padding={2}
          sx={{ alignItems: "center" }}
        >
          <Grid item md={2} xs={12}>
            <Typography noWrap sx={{ ..._STYLES.typographyLabelTitle }}>
              Adresse du bien*
            </Typography>
          </Grid>
          <Grid item md={10} xs={12}>
            <TextField
              fullWidth
              size="large"
              multiline={true}
              rows={3}
              id="adressBien"
              label="Adresse du bien"
              value={
                currentMandat?.bien?.adresse ? currentMandat.bien.adresse : ""
              }
              // Besoin de changer la valeur du state pour que le composant se rafraichisse
              onChange={(e) => {
                setCurrentMandat({
                  ...currentMandat,
                  bien: {
                    ...currentMandat.bien,
                    adresse: e.target.value,
                  },
                });
              }}
              // On envoie la valeur au serveur
              onBlur={(e) => {
                let m = editInstantRequest(
                  e.target.value,
                  currentMandat.bien["@id"],
                  "adresse",
                );

                refresh();
              }}
              helperText={
                errors?.biens?.adresse?.type === "required" && (
                  <Typography sx={_STYLES.errorMessage}>
                    Adresse est requis
                  </Typography>
                )
              }
            />
          </Grid>
        </Grid>
        <Grid sx={{ ..._STYLES.sxGridChild, backgroundColor: "#f7e0eb" }}>
          <VentilationPrixLettreIntentionAchat
            register={register}
            errors={errors}
            indices={indices}
            currentMandat={currentMandat}
            setCurrentMandat={setCurrentMandat}
            refresh={refresh}
            requestHelper={requestHelper}
            disabledSign={disabledSign}
          />
        </Grid>
        <RemunerationAgence
          currentMandat={currentMandat}
          setCurrentMandat={setCurrentMandat}
          refresh={refresh}
          register={register}
          field={"libre"}
          disabledSign={disabledSign}
        />
        <Grid container columnSpacing={1} rowSpacing={3} padding={4}>
          <InputLabel id="dateLabel" size="small" sx={{ color: "black" }}>
            Cette proposition est valable jusqu'au (inclus)*
          </InputLabel>{" "}
          <DatePicker
            sx={{ paddingLeft: "10px", marginTop: "10px" }}
            size="small"
            value={
              currentMandat.dateFinLettreIntention
                ? moment(currentMandat.dateFinLettreIntention)
                : null
            }
            format="DD/MM/YYYY"
            onChange={(date) => {
              let dateToSend = date?.toLocaleString("fr-FR", {
                timeZone: "Europe/paris",
              });
              if (dateToSend !== "Invalid date") {
                editInstantRequest(
                  _.isNull(dateToSend) ? null : dateToSend,
                  currentMandat["@id"],
                  "dateFinLettreIntention",
                );
                refresh();
              }
            }}
            slotProps={{
              textField: {
                size: "small",
              },
            }}
          />
        </Grid>
        {/*<Grid sx={{ ..._STYLES.sxGridChild }}>
          <Box sx={{ flexGrow: 1, padding: 4 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Typography
                  variant="h5"
                  style={{
                    fontWeight: "bold",
                    color: _COLORS.primary,
                  }}
                >
                  Signatures
                </Typography>
              </Grid>
              {<Grid item xs={12} sx={{ display: "flex", gap: 2 }}>
                <Typography>Signataire des mandataires</Typography>
                <Grid item xs={4}>
                  <fieldset disabled={disabledSign}>
                    <FormControl fullWidth>
                      <InputLabel> Signataire :</InputLabel>
                      <Select
                        label="Signataire :"
                        sx={{ border: "none" }}
                        size="small"
                        {...register("signataire", { required: false })}
                        value={
                          currentMandat?.signataire
                            ? currentMandat?.signataire?.["@id"]
                            : ""
                        }
                        fullWidth
                        disabled={disabledSign}
                        onChange={(e) => {
                          let value =
                            e.target.value === "null" ? null : e.target.value;
                          let m = editInstantRequest(
                            value,
                            currentMandat["@id"],
                            "signataire",
                          );

                          m.then((m) => {
                            if (m["@context"] === "/api/contexts/Error") {
                              refresh();
                            } else {
                              setCurrentMandat(m);
                            }
                          });
                        }}
                      >
                        <MenuItem value="null">Aucun Signataire</MenuItem>
                        {users.map((u, i) => (
                          <MenuItem key={i} value={u["@id"]}>
                            {u.prenom + " " + u.nom}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </fieldset>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>*/}
        <Grid sx={_STYLES.sxGridChild}>
          <AnnexesDocumentaires
            errors={errors}
            register={register}
            typeDocuments={typeDocuments}
            refresh={refresh}
            currentMandat={currentMandat}
            disabledSign={disabledSign}
            isOffreAchat={true}
          />
        </Grid>
      </Grid>
      <BoxActionOffreAchat
        requestHelper={requestHelper}
        refresh={refresh}
        currentMandat={currentMandat}
        disabledSign={disabledSign}
      />
    </>
  );
};

export default CreationOffreAchat;
